export class GrpcError extends Error {
  loaderKey: string;
  originalError: any;
  details: any;
  override message: any;
  constructor(loaderKey: string, originalError: any, details: any) {
    super(originalError.statusMessage || originalError.message);
    this.loaderKey = loaderKey;
    this.originalError = originalError;
    this.message = originalError.statusMessage || originalError.message || originalError;
  }
}
